<template>
  <div class="Menu">
    <BurgerMenu />
    <SidebarMenu>
      <NavigationMenu />
    </SidebarMenu>
  </div>
</template>

<script>
import BurgerMenu from "@/components/menu/Burger"
import SidebarMenu from "@/components/menu/Sidebar"
import NavigationMenu from "@/components/menu/Navigation"

export default {
  components: {
    BurgerMenu,
    SidebarMenu,
    NavigationMenu
  }
}
</script>

<style lang="scss">
.Menu {
  height: 100vh;

  .main-nav {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 0.8rem;
  }

  ul.sidebar-panel-nav {
    list-style-type: none;
  }

  ul.sidebar-panel-nav > li > a {
    color: #fff;
    text-decoration: none;
    font-size: 1.5rem;
    display: block;
    padding-bottom: 0.5em;
  }
}
</style>
